module.exports = __webpack_public_path__ + "static/opener-text-sml-94d7cff8944254b3adfe298f26626330.png";